import * as React from 'react';

import { Row } from '@rematter/ui-web';

export const ItemHeaderCell: React.FC<React.PropsWithChildren> = ({
  children,
}) => (
  <Row className="@ItemHeaderCell truncate text-[0.625rem] font-medium text-neutral/60 uppercase">
    {children}
  </Row>
);
